import { useQuery } from "@tanstack/react-query";
import type { SellerShippingRuleView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

type UseShippingRulesQueryParams = {
  storeSlug: string;
  enabled?: boolean;
};

export function useShippingRulesQuery({
  storeSlug,
  enabled = true,
}: UseShippingRulesQueryParams) {
  const query = useQuery({
    queryKey: queryKeys.seller.shippingRules(storeSlug),
    queryFn: () =>
      apiJsonClient<SellerShippingRuleView[]>(endpoints.seller.storeShippingRules, {
        cache: "no-store",
      }),
    enabled: storeSlug.length > 0 && enabled,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
  };
}
